import { PRODUCT_NAME } from '../../api/src/product';

export { PRODUCT_NAME };

/** Who to write to about the paid plan. */
export const UPGRADE_MAIL: string = `mailto:support@eightythreelabs.com?subject=${encodeURIComponent(`Upgrade ${PRODUCT_NAME}`)}`;
